import { API } from "./API";
import { InternetConnectionError } from "./HttpRequest";
import { delay } from "./system/delay";

export class ApiWithRetry {
    didCancel: boolean = false;

    cancel() {
        if (this.didCancel) {
            throw new Error("Already cancelled");
        }
        this.didCancel = true;
    }

    /**
     * This should only be called once
     *
     * @returns Null if fetch was cancelled
     */
    async fetch<T>(apiCall: () => Promise<T>, delayTimer: number = 1000): Promise<T | null> {
        try {
            return await apiCall();
        } catch (err) {
            const retry = async () => {
                await delay(delayTimer);

                if (this.didCancel) {
                    return null;
                }

                return this.fetch(apiCall, Math.min(delayTimer * 2, 4000));
            };
            if (err instanceof InternetConnectionError) {
                return retry();
            } else if (err instanceof API.ServerError) {
                return retry();
            } else {
                throw err;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/ExponentialBackOffNetworkRequest.ts